import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'participantProgress',
    label: 'Participant Progress',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
